import { render, staticRenderFns } from "./VLoader.vue?vue&type=template&id=7cf15fe8"
import script from "./VLoader.vue?vue&type=script&lang=js"
export * from "./VLoader.vue?vue&type=script&lang=js"
import style0 from "./VLoader.vue?vue&type=style&index=0&id=7cf15fe8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports